import EcSelect from "@/components/EcSelect";
import { EcSelectData } from "@/components/EcSelect/type";
import TableSearchState from "@/scenes/OrderManagement/redux/states/TableSearchState";
import { FILTER_UNDELIVERABLE, SELECT_UNDELIVERABLE } from "@/services/undeliverableAreaService";
import { useOrderSettingStore } from "@/store/hooks";
import { Button, Form, Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { useHistory } from "react-router";

interface UndeliverableAreaFieldProps {}

const UndeliverableAreaField: React.FC<UndeliverableAreaFieldProps> = function (props) {
    const [tooltipVisible, updateTooltipVisible] = useState(false);
    const history = useHistory();

    function handleSettingClick() {
        history.push("/setting/undeliverableArea");
    }

    const { undeliverableAreaList } = useOrderSettingStore();

    return (
        <Tooltip
            trigger="click"
            placement="top"
            open={tooltipVisible}
            onOpenChange={updateTooltipVisible}
            title={() => {
                return (
                    <div style={{ fontSize: "11px" }}>
                        <p>1 不可达地区需要开启后才能在这里过滤或者筛选</p>
                        <p>2 选择某个不可达过滤后，就会只显示对应可达订单</p>
                        <p>3 选择某个不可达筛选后，就会只显示不可达订单</p>
                    </div>
                );
            }}
        >
            <span>
                <Form.Item<TableSearchState>
                    noStyle
                    shouldUpdate={(prev, next) => prev.undeliverableArea !== next.undeliverableArea}
                >
                    {(form) => {
                        const data = (() => {
                            const { undeliverableArea } = form.getFieldsValue();

                            if (!undeliverableAreaList?.length) return [];

                            const enableUndeliverableAreaList = undeliverableAreaList.filter(({ enable }) => enable);
                            const length = enableUndeliverableAreaList.length;
                            const options = new Array<EcSelectData>(length * 2);
                            const currentActive = undeliverableArea?.[0]
                                ? undeliverableArea[0].startsWith(FILTER_UNDELIVERABLE)
                                    ? FILTER_UNDELIVERABLE
                                    : SELECT_UNDELIVERABLE
                                : undefined;
                            const tooltip = "不能同时过滤和筛选不可达";

                            /** Item被禁用都是由tooltip */
                            enableUndeliverableAreaList.forEach(({ id, name }, index) => {
                                options[index] = {
                                    value: FILTER_UNDELIVERABLE + id,
                                    label: name,
                                    tooltip: currentActive === SELECT_UNDELIVERABLE ? tooltip : undefined,
                                };
                                options[index + length] = {
                                    value: SELECT_UNDELIVERABLE + id,
                                    label: name,
                                    tooltip: currentActive === FILTER_UNDELIVERABLE ? tooltip : undefined,
                                };
                            });

                            return options;
                        })();

                        return (
                            <Form.Item
                                name="undeliverableArea"
                                label={<span className="search-field-label">不可达</span>}
                            >
                                <EcSelect
                                    multiple
                                    data={data}
                                    prevRender={() => {
                                        return (
                                            <Button type="link" onClick={handleSettingClick}>
                                                设置不可达地区...
                                            </Button>
                                        );
                                    }}
                                    groupOptions={{
                                        groupBy({ value }) {
                                            if (value.startsWith(FILTER_UNDELIVERABLE)) {
                                                return "仅过滤不可达";
                                            }

                                            if (value.startsWith(SELECT_UNDELIVERABLE)) {
                                                return "仅筛选不可达";
                                            }

                                            return "";
                                        },
                                    }}
                                    disabledItem={({ value }) => {
                                        const { undeliverableArea } = form.getFieldsValue();

                                        if (value.startsWith(FILTER_UNDELIVERABLE)) {
                                            return (
                                                undeliverableArea?.findIndex((it) =>
                                                    it.includes(SELECT_UNDELIVERABLE),
                                                ) > -1
                                            );
                                        }

                                        if (value.startsWith(SELECT_UNDELIVERABLE)) {
                                            return (
                                                undeliverableArea?.findIndex((it) =>
                                                    it.includes(FILTER_UNDELIVERABLE),
                                                ) > -1
                                            );
                                        }

                                        return false;
                                    }}
                                />
                            </Form.Item>
                        );
                    }}
                </Form.Item>
            </span>
        </Tooltip>
    );
};

export default observer(UndeliverableAreaField);
